<template>
    <div style="text-align: center">
        <h1 id="timer">{{ displayTime }}</h1>
        <p>
            <v-btn outline small color="teal" dark fab @click="reset"><v-icon>restore</v-icon></v-btn>
            <v-btn outline small color="teal" dark fab @click='start'><v-icon>{{btnLabelStart}}</v-icon></v-btn>
        </p>  
    </div>
</template>

<script>

function StopWatch(elementBinded){
    var time = 0 // currrent time at stopWatch
    var interval // the time split
    var offset // started time

    function update () {
        time += delta()
        var formattedTime = timeFormatter(time)
        elementBinded = formattedTime
    }

    function delta () {
        var now = Date.now()
        var timePassed = now - offset
        offset = now
        return timePassed
    }

    function timeFormatter (timeMilliSeconds) {
        var time = new Date(timeMilliSeconds)
        var minutes = time.getMinutes().toString()
        var seconds = time.getSeconds().toString()
        var milliseconds = time. getMilliseconds().toString()

        if(minutes.length < 2){
            minutes = '0' + minutes
        }

        if(seconds.length < 2){
            seconds = '0' + seconds
        }

        while(milliseconds.length < 3){
            milliseconds = '0' + milliseconds
        }

        return minutes + ' : ' + seconds + ' . ' + milliseconds.substring(0,1)
    }

    this.isOn = false
    this.start = function () {
        if(!this.isOn){
            interval = setInterval(update, 10)
            offset = Date.now()
            this.isOn = true
        }
    }

    this.stop = function () {
        clearInterval(interval)
        this.interval = null
        this.isOn = false
    }

    this.reset = function () {
        this.time = 0
    }
}
var globalInterval = null

export default {
    name: 'PtkStopWatch',
    data: () => ({
        btnLabelStart: 'play_arrow',
        displayTime: "00 : 00", // "00 : 00 . 0000",
        time: 0,
        interval: null,
        offset: null,
        isOn: false
    }),
    methods: {
        start(){
            this.btnLabelStart = this.btnLabelStart == 'play_arrow' ? 'pause' : 'play_arrow'
            if(!this.isOn){
                // globalInterval = setInterval(function(){
                this.interval = setInterval(function(){
                    this.time += this.delta
                    let formattedTime = this.timeFormatter(this.time)
                    this.displayTime = formattedTime
                }.bind(this), 1000)
                this.offset = Date.now()
                this.isOn = true
            } else {
                clearInterval(this.interval)
                this.interval = null
                // clearInterval(globalInterval)
                // globalInterval = null
                this.isOn = false
            }
        },
        reset() {
            this.btnLabelStart = 'play_arrow'
            this.time = 0
            this.displayTime = "00 : 00" // "00 : 00 . 000"
            if(this.isOn){
                clearInterval(this.interval)
                this.interval = null
                // clearInterval(globalInterval)
                // globalInterval = null
                this.isOn = false
            }
        },
        timeFormatter(timeMilliSeconds){
            let localTime = new Date(timeMilliSeconds)
            let minutes = localTime.getMinutes().toString()
            let seconds = localTime.getSeconds().toString()
            let milliseconds = localTime. getMilliseconds().toString()

            if(minutes.length < 2){
                minutes = '0' + minutes
            }
            if(seconds.length < 2){
                seconds = '0' + seconds
            }
            while(milliseconds.length < 3){
                milliseconds = '0' + milliseconds
            }
            return minutes + ' : ' + seconds //+ ' . ' + milliseconds
        }
    },
    computed: {
        delta: function () {
            let now = Date.now()
            let timePassed = now - this.offset
            this.offset = now
            return timePassed
        }
    }
}
</script>

<style>
#timer{
    font-family: "Lato";
    font-weight: 300
}
</style>



// WEBPACK FOOTER //
// src/components/PtkStopWatch.vue